import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { videoContainerStyles } from '../../../constants/constants';
import dataAids from '../../../constants/dataAids';

const Video = props => {
  return (
    <UX2.Element.Block style={ videoContainerStyles }>
      <UX2.Element.Embed
        tag='iframe'
        allowFullScreen
        type='text/html'
        frameBorder='0'
        data-aid={ dataAids.VIDEO_IFRAME_RENDERED }
        src={ props.videoUrl }
      />
    </UX2.Element.Block>
  );
};

Video.propTypes = {
  videoUrl: PropTypes.string
};

export default Video;
